import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import defaultStyles from './navBar.module.scss';
import defaultItemStyles from './navbaritem/navBarItem.module.scss';
import NavBarItem from './navbaritem/NavBarItem';
import AppInfoItem from './appinfoitem/AppInfoItem';

const NavBar = ({ styles, ...props }) => {
    const navBarItems = props.navItems.map((item, index) => {
        const i = index;
        const active = (item.url && window.location.pathname
            .toLowerCase()
            .startsWith(item.url.toLowerCase())
        ) || item.active;
        return (
            <NavBarItem
                key={ i }
                url={ item.url }
                title={ item.title }
                icon={ item.icon }
                active={ active }
                showHover
            />
        );
    });

    const appInfoItems = props.appInfoItems.map((item) => (
        <AppInfoItem
            key={ item.title }
            Component={ () => item.Component }
            icon={ item.icon }
        />
    ));

    const titleNavBarItem = useMemo(() => (
        <NavBarItem
            key="title"
            url={ props.defaultUrl }
            title={ props.title }
            icon={ props.titleIcon }
            active={ false }
            largeFont
            styles={ props.titleStyles }
        />
    ), [
        props.defaultUrl,
        props.title,
        props.titleIcon,
        props.titleStyles
    ]);

    return (
        <nav className={ styles.navBar }>
            { !props.hideTitle && titleNavBarItem }
            { navBarItems }
            { props.appInfoItems && (
                <div className={ styles.appInfoContainer }>
                    { appInfoItems }
                </div>
            ) }
        </nav>
    );
};

NavBar.propTypes = {
    navItems: PropTypes.arrayOf(
        PropTypes.shape({
            url: PropTypes.string,
            title: PropTypes.string,
            icon: PropTypes.string,
            active: PropTypes.bool
        })
    ),
    styles: PropTypes.objectOf(PropTypes.string),
    titleStyles: PropTypes.objectOf(PropTypes.string),
    titleIcon: PropTypes.string,
    title: PropTypes.string,
    hideTitle: PropTypes.bool,
    defaultUrl: PropTypes.string,
    appInfoItems: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string,
        icon: PropTypes.string,
        component: PropTypes.func
    })),
};

NavBar.defaultProps = {
    navItems: [],
    styles: defaultStyles,
    titleStyles: defaultItemStyles,
    titleIcon: null,
    title: null,
    hideTitle: false,
    defaultUrl: '/',
    appInfoItems: []
};

export default NavBar;
